export default "__VITE_ASSET__e0e7b22d__"